
/**
 * Form Field Text
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var FormFieldNumber = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$input = this.options.$el.find("input");

};

/**
 * Init
 * @return {[type]} [description]
 */
FormFieldNumber.prototype.init = function(){

  var self = this;

  this.$input.on("focus", function(){
    self.options.$el.addClass("is-focused");
  });

  this.$input.on("blur", function(){
    if(! self.checkValue()){
      self.options.$el.removeClass("is-focused");
    }
  });

  if(self.checkValue()){
    self.options.$el.addClass("is-focused");
  }

};

/**
 * Does the form field have value
 * @return {[type]} [description]
 */
FormFieldNumber.prototype.checkValue = function(){

  return this.$input.val().length > 1 ? true : false;

};

export default  FormFieldNumber;
